<template>
  <div style="height:100%;overflow-y:auto;" ref="editorWrap">
  </div>
</template>

<script>
import wangEditor from 'wangeditor';
const { BtnMenu } = wangEditor

// 保存
class SaveMenu extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<div class="w-e-menu" data-title="保存"><i class="w-e-icon-save"></i></div>`
    )
    super($elem, editor)
  }
  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.saveMenuCb(editor);
    }
  }
  tryChangeActive () {
  }
}

// 历史记录
class HistroyRecord extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<div class="w-e-menu" data-title="历史记录"><i class="w-e-icon-histroyRecord"></i></div>`
    )
    super($elem, editor)
  }
  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.historyCb(editor);
    }
  }
  tryChangeActive () {
  }
}

// 全屏
class FullScreen extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<div class="w-e-menu" data-title="全屏"><i class="w-e-icon-fullscreen"></i></div>`
    )
    super($elem, editor);
    this.isExit = false;
    editor.fullCancleCb = () => {
      this.toggleHandler(editor);
    }
  }

  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.fullScreenCb(editor, this.isExit);
      this.toggleHandler(editor);
    }
  }
  toggleHandler (editor) {
    this.isExit = !this.isExit;
    const toolbarElem = editor.$toolbarElem.elems[0];
    toolbarElem.getElementsByClassName('w-e-icon-fullscreen')[0].classList.toggle('w-e-icon-fullscreen_exit')
  }
  tryChangeActive () {
  }
}

// 漂浮
class FloatScreen extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<div class="w-e-menu" data-title="漂浮"><i class="w-e-icon-floatscreen"></i></div>`
    )
    super($elem, editor);
    this.isFloat = false;
    editor.floatCancleCb = () => {
      this.toggleHandler(editor);
    }
  }
  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.floatScreenCb(editor, this.isFloat);
      this.toggleHandler(editor);
    }
  }
  toggleHandler (editor) {
    this.isFloat = !this.isFloat;
    const toolbarElem = editor.$toolbarElem.elems[0];
    toolbarElem.getElementsByClassName('w-e-icon-floatscreen')[0].classList.toggle('w-e-icon-floatscreen_exit')
  }
  tryChangeActive () {
  }
}

// 放大
class ZoomUp extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<button
        class="w-e-menu-tools-btn zoom-up"
        @click="cailiaoZoomUp"
      ></button>`
    )
    super($elem, editor)
  }
  // 菜单点击事件
  clickHandler() {
    
    const editor = this.editor;
    if (editor) {
      editor.zoomUpCb(editor);
    }
  }
  tryChangeActive () {
  }
}

// 缩小
class ZoomDown extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<button
        class="w-e-menu-tools-btn zoom-down"
      ></button>`
    )
    super($elem, editor)
  }
  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.zoomDownCb(editor);
    }
  }
  tryChangeActive () {
  }
}

// 等比100%
class ZoomDefault extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<button
        class="w-e-menu-tools-btn zoom-default"
      ></button>`
    )
    super($elem, editor)
  }
  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.zoomDefaultCb(editor);
    }
  }
  tryChangeActive () {
  }
}

// 适应
class ZoomJust extends BtnMenu {
  constructor (editor) {
    const $elem = wangEditor.$(
      `<button
        class="w-e-menu-tools-btn zoom-just"
      ></button>`
    )
    super($elem, editor)
  }
  // 菜单点击事件
  clickHandler () {
    const editor = this.editor;
    if (editor) {
      editor.zoomJustCb(editor);
    }
  }
  tryChangeActive () {
  }
}

export default {
  data () {
    return {
      editor: null,
      editorData: '',
      rowCounts: 0,
      zoom: 1
    }
  },
  props: {
    showToolBar: {
      type: Boolean,
      default: true
    },
    value: String,
    toolbar: Array,
    saveMenuCb: Function,
    historyCb: Function,
    fullScreenCb: Function,
    floatScreenCb: Function,
    isFloat: Boolean,
    isFull: Boolean,
    topic: Object,
    disable: Boolean
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val) {
          if (val !== this.editorData) {
            //this.$emit("blur",this.editorData);
            this.setContent(val);
          }
        } else {
          this.setContent('');
        }
      }
    },
    editorData: function (news) {
      this.$emit("input", news);
    },
    zoom () {
      const ediotrText = this.editor.$textElem.elems[0];
      ediotrText.style.transform = `scale(${this.zoom})`;
      this.canvas.style.width = `${560 * this.zoom}px`;
      // ediotrText.style.zoom = this.zoom;
      this.renderEditorBg();
    }
  },
  mounted () {
    const div = document.createElement('div');
    const editorimp = `editor-${new Date().getTime()}`
    div.setAttribute('id', editorimp);
    div.classList.add('weditor')
    this.$refs.editorWrap.appendChild(div)
    const editor = new wangEditor(`#${editorimp}`);
    // 配置 onchange 回调函数，将数据同步到 vue 中
    editor.saveMenuCb = this.saveMenuCb;
    editor.historyCb = this.historyCb;
    editor.fullScreenCb = this.fullScreenCb;
    editor.floatScreenCb = this.floatScreenCb;
    editor.zoomUpCb = this.zoomUpCb;
    editor.zoomDownCb = this.zoomDownCb;
    editor.zoomDefaultCb = this.zoomDefaultCb;
    editor.zoomJustCb = this.zoomJustCb;

    // 自定义菜单
    editor.menus.extend('saveMenu', SaveMenu);
    editor.menus.extend('histroyRecord', HistroyRecord);
    
    editor.menus.extend('floatScreen', FloatScreen);
    editor.menus.extend('fullScreen', FullScreen);
    editor.menus.extend('zoomUp', ZoomUp);
    editor.menus.extend('zoomDown', ZoomDown);
    editor.menus.extend('zoomDefault', ZoomDefault);
    editor.menus.extend('zoomJust', ZoomJust);

    editor.config.onchange = (newHtml) => {
      this.editorData = newHtml;
      // 计算行数
      this.calcRowCount(newHtml);
    }
    let this_ = this;
    editor.config.onblur = function () {

      this_.$emit("blur")
    }
    editor.config.placeholder = "";
    editor.config.menus = this.toolbar || [
      'saveMenu',
      'justify',
      'histroyRecord',
      
      'floatScreen',
      'fullScreen',
      'zoomUp',
      'zoomDown',
      'zoomJust',
      'zoomDefault'
    ]
    editor.create();
    editor.txt.html(this.editorData);

    this.editor = editor;

    editor.config.focus = false;
    if (this.disable) {
      editor.$textElem.attr('contenteditable', false);
    }

    if (this.isFloat) {
      this.editor.floatCancleCb();
    }
    if (!this.showToolBar) {
      editor.$toolbarElem.elems[0].style.display = 'none';
    }
    // 准备计算行数的dom
    const calcEle = document.createElement('div');
    calcEle.classList.add('w-e-text-calc-wrap')
    calcEle.setAttribute('id', 'calc-wrap' + editor.textElemId);
    calcEle.innerHTML = `<div class="w-e-text-calc" id="calc${editor.textElemId}"></div>`;
    editor.$textElem.elems[0].parentNode.appendChild(calcEle);
    // 离屏canvas
    const canvas = document.createElement('canvas');
    canvas.classList.add('offCanvas');
    canvas.width = "560";
    canvas.height = "500";
    const ctx = canvas.getContext('2d');
    editor.$textElem.elems[0].parentNode.appendChild(canvas);
    this.canvas = canvas;
    this.ctx = ctx;

    this.zoom = (this.$refs.editorWrap.clientWidth - 20) / 560;

  },
  methods: {
    setContent (val) {
      this.editorData = val;
      if (this.editor) {
        this.editor.txt.html(val);
      }
    },
    calcRowCount(editorHtml, isChange) {
      const ediotrText = this.editor.$textElem.elems[0];
      const calcEle = document.getElementById('calc' + this.editor.textElemId);
      calcEle.innerHTML = ediotrText.innerHTML;
      const offH = calcEle.offsetHeight;
      const rows = (offH - 3) / 28;
      
      this.reflushEditorStyle(rows, editorHtml, isChange);
    },
    reflushEditorStyle(rows, editorHtml, isChange) {
      
      if (!isChange) {
        if (this.editor && rows > this.topic.word_row_limit) {
          this.$tip({ text: "作答字数已超过篇幅要求！", time: 5 });
          this.editor.txt.html(this.beforEditorChange);
          this.$nextTick(() => {
            document.querySelector(".windowContent").querySelector(".btn").focus();
          })
          return;
        }
        this.beforEditorChange = editorHtml;
        if (this.rowCounts !== rows) {
          this.rowCounts = rows;
          // 绘制背景图
          this.renderEditorBg();
        }
      } else {
        this.renderEditorBg();
      }
    },
    renderEditorBg () {
      // 重定义编辑区高度
      const ediotrText = this.editor.$textElem.elems[0];
      ediotrText.style.height = (28 * this.topic.word_row_limit + 4) * this.zoom + 'px';
      if (this.zoom > 1) {
        ediotrText.style.height = (28 * this.topic.word_row_limit + 4) + 10 + 'px';
      }
      this.canvasDraw();
    },
    canvasDraw () {
      const ratio = window.devicePixelRatio || 1;
      const zoom = this.zoom * ratio;
      const canvas = this.canvas;
      const width = 560 * zoom;
      const height = (28 * this.topic.word_row_limit + 4) * zoom;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, width, height); // 清空画布
      // 绘制白色背景
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, width, height);

      ctx.scale(zoom, zoom);
      // // 绘制间隔线
      ctx.save();
      ctx.strokeStyle = '#f2f2f2';
      ctx.font = "12px 宋体";
      ctx.textAlign = 'end';
      ctx.textBaseline = 'bottom';
      ctx.fillStyle = '#F97A7A';
      for (let i = 1; i < 128; i++) {
        ctx.beginPath();
        ctx.moveTo(0, 28 * i + 3.5);
        ctx.lineWidth = 1;
        ctx.lineTo(560, 28 * i + 3.5);
        ctx.stroke();
        // 字数标记
        if (i % 4 === 0) {
          ctx.fillText(i * 25 + '字', 558.5, 28 * i + 0.5);
        }
      }
      ctx.restore();

      // 绘制顶部虚线
      ctx.save();
      ctx.strokeStyle = '#CECFCF';
      ctx.beginPath();
      ctx.moveTo(9.5, 3.5);
      ctx.setLineDash([4, 2]);
      ctx.lineWidth = 1;
      ctx.lineTo(549.5, 3.5);
      ctx.stroke();
      // 绘制左侧虚线
      ctx.beginPath();
      ctx.moveTo(30.5, 0);
      ctx.setLineDash([4, 2]);
      ctx.lineWidth = 1;
      ctx.lineTo(30.5, 3610);
      ctx.stroke();
      // 绘制右侧虚线
      ctx.beginPath();
      ctx.moveTo(520.5, 0);
      ctx.setLineDash([4, 2]);
      ctx.lineWidth = 1;
      ctx.lineTo(520.5, 3610);
      ctx.stroke();
      // 绘制左侧文字
      ctx.font = "14px 宋体";
      ctx.fillStyle = '#c0c0c0';
      for (let i = 1; i <= this.rowCounts; i++) {
        ctx.textAlign = 'end';
        ctx.fillText(i, 24, 23 + (28 * (i - 1)));
      }
      ctx.restore();

      // const editorBGUrl = canvas.toDataURL();
      // const ediotrText = this.editor.$textElem.elems[0];
      // ediotrText.style.backgroundImage = `url(${editorBGUrl})`;
    },
    zoomUpCb () {
      this.zoomjustFlag = false;
      if (this.zoom < 3) {
        this.zoom = (Number(this.zoom) + 0.1).toFixed(1);
        
      }
    },
    zoomDownCb () {
      this.zoomjustFlag = false;
      if (this.zoom > 0.1) {
        this.zoom = (this.zoom - 0.1).toFixed(1);
      }
    },
    zoomDefaultCb () {
      this.zoomjustFlag = false;
      this.zoom = 1;
    },
    zoomJustCb (editor) {
      if (editor) {
        this.zoomjustFlag = true;
      }
      if (this.zoomjustFlag) {
        const container = this.editor.$textElem.elems[0].parentNode;
        const containerW = container.offsetWidth - 60;
        const zoom = containerW / 560;
        this.zoom = zoom.toFixed(1);
      }
    },
    scrollBack () {
      const container = this.editor.$textElem.elems[0].parentNode;
      if (container) {
        container.scrollTop = 0;
      }
    }
  },
  beforeDestroy () {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.$emit("blur");
    this.editor.destroy()
    this.editor = null
  }
}
</script>

<style lang="scss">
.weditor {
  height: 100%;

  .w-e-text-container {
    height: calc(100% - 36px) !important;
    overflow: auto;
    background-color: #c6cace;
    border: none !important;

    .w-e-text {
      // height: 3400px !important;
      width: 560px !important;
      // min-height: 500px !important;
      padding: 3px 42px 0 32px;
      margin: 30px auto;
      overflow: hidden;
      font-size: 19px;
      transform-origin: top;
      position: relative;
      z-index: 13000;

      p {
        margin: 0;
        line-height: 28px;
        word-break: break-word;
        
      }
    }

    .w-e-text-calc-wrap {
      width: 0;
      height: 0;
      overflow: hidden;
    }

    .w-e-text-calc {
      height: auto;
      width: 560px !important;
      padding: 3px 42px 0 32px;
      margin: 30px auto;
      overflow: hidden;
      font-size: 19px;

      p {
        margin: 0;
        line-height: 28px;
        word-break: break-word;
      }
    }
  }

  .offCanvas {
    // display: none;
    margin: 30px auto;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 12000;
    width: 560px;
  }

  .w-e-toolbar {
    background-color: #f6f6f6 !important;
  }

  .w-e-full-screen-editor {
    width: 100% !important;
    height: 100% !important;
    left: 0;
    top: 0;
  }

  .w-e-menu>.w-e-icon-save::before {
    content: "保存";
  }

  .w-e-menu>.w-e-icon-paragraph-left::before {
    content: "对齐";
  }

  .w-e-menu>.w-e-icon-histroyRecord::before {
    content: "历史记录";
  }

  .w-e-menu>.w-e-icon-fullscreen::before {
    content: "全屏";
  }

  .w-e-menu>.w-e-icon-fullscreen_exit::before {
    content: "取消全屏";
  }

  .w-e-menu>.w-e-icon-floatscreen::before {
    content: "漂浮";
  }

  .w-e-menu>.w-e-icon-floatscreen_exit::before {
    content: "取消漂浮";
  }

  .w-e-menu-tools-btn {
    width: 30px;
    height: 30px;
    cursor: pointer;
    outline: 0;
    border: none;
    margin-right: 4px;
    float: right;
    position: absolute;
    top: 1px;

    &.zoom-up {
      background: url(../../assets/image/exam/6-default.png);
      background-size: cover;
      right: 96px;

      &:hover {
        background: url(../../assets/image/exam/6-hover.png);
        background-size: cover;
      }

      &:active {
        background: url(../../assets/image/exam/6-selected.png);
        background-size: cover;
      }
    }

    &.zoom-down {
      background: url(../../assets/image/exam/7-default.png);
      background-size: cover;
      right: 64px;

      &:hover {
        background: url(../../assets/image/exam/7-hover.png);
        background-size: cover;
      }

      &:active {
        background: url(../../assets/image/exam/7-selected.png);
        background-size: cover;
      }
    }

    &.zoom-default {
      background: url(../../assets/image/exam/8-default.png);
      background-size: cover;
      right: 0px;

      &:hover {
        background: url(../../assets/image/exam/8-hover.png);
        background-size: cover;
      }

      &:active {
        background: url(../../assets/image/exam/8-selected.png);
        background-size: cover;
      }
    }

    &.zoom-just {
      background: url(../../assets/image/exam/10-default.png);
      background-size: cover;
      right: 32px;

      &:hover {
        background: url(../../assets/image/exam/10-hover.png);
        background-size: cover;
      }

      &:active {
        background: url(../../assets/image/exam/10-selected.png);
        background-size: cover;
      }
    }
  }

  .w-e-toolbar {
    .w-e-menu {
      width: auto;
      height: 30px;
      border: 1px solid transparent;
      margin: 2px 0;
      border-radius: 4px;
      padding: 0 6px;

      &:hover {
        border: 1px solid #acacac;
      }

      i {
        color: #333;
      }

      &:last-child {
        display: none;
      }
    }
  }

  .w-e-droplist {
    .w-e-list {
      .w-e-item:last-child {
        display: none;
      }
    }
  }
}
</style>